'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default function projectMaintenanceTable() {
    return {
        restrict: 'A',
        template: require('../view/table.html'),
        transclude: false,
        scope: {
            maintenanceKind: '=myMaintenanceKind',
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            project: '=myProject',
            edit: '=edit',
            partialEdit: '=?partialEdit',
            showPartial: '=?myShowPartial',
            cancelPartial: '=?myCancelPartial',
            editingPartial: '=?myEditingPartial',
            savePartial: '=?mySavePartial',
        },
        controller: ['$scope', '$utils', 'filterFilter', 'ProjectMaintenanceService', 'AttachmentService', 'ProjectUtils',
            function($scope, $utils, $filter, ProjectMaintenanceService, AttachmentService, ProjectUtils) {
                $scope.select = select;
                $scope.refresh = refresh;
                $scope.dblClick = dblClick;
                $scope.isSelect = isSelect;
                $scope.getItems = getItems;
                $scope.getValue = $utils.getValue;
                $scope.showAttachments = AttachmentService.show;
                $scope.getArrayValue = (item) => {
                    if (!Array.isArray(item)) return '';
                    return item.map(val => {
                        if (val.responsibleStaff && val.responsibleStaff.fullName) {
                            return val.responsibleStaff.fullName;
                        } else if 
                        (val.responsibleOrg && val.responsibleOrg.fullName) {
                            return '';
                        }
                    }).join(', ');
                }

                $scope.isExpired = isExpired;

                let maxIndex = -1;

                init();

                // region Function

                function init() {
                    if (!$scope.selectedItem) {
                        $scope.selectedItem = {};
                    }

                    $scope.columns = [{
                        name: 'Направление деятельности',
                        data: 'parentActivityName',
                    }, {
                        name: 'Ответственные лица',
                        data: 'responsibilities',
                        type: 'array'
                    }, {
                        name: 'Мероприятие',
                        data: 'activityName',
                    }, {
                        name: 'Дата начала мероприятия',
                        data: 'startDateFact',
                        type: 'date',
                    }, {
                        name: 'Плановая дата завершения',
                        data: 'doneDatePlan',
                        type: 'date',
                    }, {
                        name: 'Фактическая дата',
                        data: 'doneDateFact',
                        type: 'date',
                    }, {
                        name: 'Результат',
                        data: 'result',
                    }, {
                        name: 'Вложения',
                        data: 'attachments',
                        type: 'attachments',
                    }];

                    $scope.searching = {
                        isSearch: $scope.isSearch,
                        filter: null,
                    };

                    $scope.pagination = {
                        isPaging: $scope.isPaging,
                        page: 1,
                        size: $scope.isPaging ? 10 : null,
                        totalPages: null,
                        totalItems: null,
                    };

                    $scope.toolbox = {
                        buttons: {
                            create: {
                                show: () => $scope.edit,
                                click: () => ProjectMaintenanceService.create({
                                    maintenanceKind: $scope.maintenanceKind,
                                    index: ++maxIndex,
                                    parentIndex: null,
                                }, $scope.edit, getItems(), $scope.project).result.then(function(data) {
                                    if (!$scope.items.some((item) => equals(item, data))) {
                                        $scope.items.push(data);
                                        ProjectUtils.sortProjectMaintenancesByNpp($scope.items);
                                    }
                                }),
                                disabled: () => $scope.maintenanceKind == null || $scope.maintenanceKind.id == null,
                            },
                            edit: {
                                show: () => true,
                                click: (item) => ProjectMaintenanceService.edit($scope.selectedItem, $scope.edit, getItems(),  $scope.project, $scope.partialEdit, $scope.showPartial, $scope.cancelPartial, $scope.editingPartial, $scope.savePartial).result.then(function(data) {
                                    angular.copy(data, item);
                                    angular.copy(data, $scope.selectedItem);
                                    let origin = $scope.items.find(((item) => equals(item, $scope.selectedItem)));
                                    if (origin != null) {
                                        angular.copy(data, origin);
                                    }
                                    ProjectUtils.sortProjectMaintenancesByNpp($scope.items);
                                    if ($scope.showPartial()) $scope.savePartial();
                                }),
                                disabled: () => !isSelected(),
                            },
                            remove: {
                                show: () => $scope.edit,
                                click: (item) => {
                                    $scope.items.splice($scope.items.indexOf($scope.items.find((it) => equals(it, item))), 1);
                                    if (Array.isArray($scope.items)) {
                                        $scope.items.filter((it) => it.parentIndex == item.index).forEach((it) => {
                                            it.parent = null;
                                            it.parentIndex = null;
                                        });
                                    }
                                    angular.copy({}, $scope.selectedItem);
                                },
                                disabled: () => !isSelected(),
                            },
                            refresh: {
                                show: () => false,
                                click: $scope.refresh,
                                disabled: () => false,
                            },
                        },
                    };
                }

                function refresh() {
                    if (!Array.isArray($scope.items)) return;

                    if (!$scope.items.every((i) => !equals(i, data))) return;

                    $scope.selectedItem = {};
                }

                function dblClick(item) {
                    switch ($scope.type) {
                        case 'table':
                            if ($scope.toolbox.buttons.edit) {
                                $scope.toolbox.buttons.edit.click(item);
                            }
                            break;
                        case 'select':
                            $scope.ok();
                            break;
                    }
                }

                function select(item) {
                    if (!$scope.isSelect(item)) {
                        angular.copy(item, $scope.selectedItem);
                    } else {
                        angular.copy({}, $scope.selectedItem);
                    }
                }

                function isSelect(item) {
                    return equals($scope.selectedItem, item);
                }

                function isSelected() {
                    return $scope.selectedItem != null && $scope.selectedItem.maintenanceKind != null && $scope.selectedItem.maintenanceKind.id != null;
                }

                function equals(i1, i2) {
                    if (i1 == null || i2 == null) {
                        return false;
                    }

                    if (i1.id != null || i2.id != null) {
                        return i1.id == i2.id;
                    }

                    return angular.equals(i1, i2);
                }

                function getItems() {
                    if (!$scope.maintenanceKind) {
                        return [];
                    }
                    if (Array.isArray($scope.items)) {
                        return $scope.items.filter((item) => item.maintenanceKind.id == $scope.maintenanceKind.id);
                    }
                    return [];
                }

                function isExpired(item) {
                    return ((item.doneDateFact == null && item.doneDatePlan != null && new Date() >= item.doneDatePlan));
                }

                // endregion

                // region Watcher

                $scope.$watch('items', () => {
                    maxIndex = -1;
                    if (Array.isArray($scope.items)) {
                        $scope.items.forEach((maintenance) => {
                            maxIndex = Math.max(maintenance.index, maxIndex);
                        });
                        ProjectUtils.sortProjectMaintenancesByNpp($scope.items);
                    }
                });

                // endregion
            }],
    };
}
